"use client";

import { forwardRef, useEffect, useState } from "react";
import type { LottieProps } from "react-lottie-player";

type PlayerComponent = typeof import("react-lottie-player/dist/LottiePlayerLight").default;

const LottiePlayer = forwardRef<any, LottieProps>(function LottiePlayer(props, ref) {
  const [Player, setPlayer] = useState<PlayerComponent | null>(null);

  useEffect(() => {
    let mounted = true;

    import("react-lottie-player/dist/LottiePlayerLight").then(({ default: LoadedPlayer }) => {
      if (mounted) setPlayer(() => LoadedPlayer);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return Player ? <Player {...props} ref={ref} /> : null;
});

export default LottiePlayer;
